import Default from './default';
import Theme1 from './theme1';
import Theme2 from './theme2';
import Theme3 from './theme3';
import Theme4 from './theme4';
import Theme5 from './theme5';
import Theme6 from './theme6';
import Theme7 from './theme7';
import Theme8 from './theme8';
import { PaletteThemeProps } from 'types/theme';
import { PalettesProps } from '@ant-design/colors';
import { ThemeMode, PresetColor } from 'types/config';
import ThemeEfp from './efp';

const Theme = (colors: PalettesProps, presetColor: PresetColor, mode: ThemeMode): PaletteThemeProps => {
    switch (presetColor) {
        case PresetColor.THEME1:
            return Theme1(colors, mode);
        case PresetColor.THEME2:
            return Theme2(colors, mode);
        case PresetColor.THEME3:
            return Theme3(colors, mode);
        case PresetColor.THEME4:
            return Theme4(colors, mode);
        case PresetColor.THEME5:
            return Theme5(colors, mode);
        case PresetColor.THEME6:
            return Theme6(colors, mode);
        case PresetColor.THEME7:
            return Theme7(colors, mode);
        case PresetColor.THEME8:
            return Theme8(colors, mode);
        case PresetColor.EFP:
            return ThemeEfp(mode);
        default:
            return Default(colors);
    }
};

export default Theme;
